import { pipe } from 'fp-ts/function';
import { array, eq, string } from 'fp-ts';
import { Bill } from '@mews-commander/data-access';
import { Highlight, NestedCard, Body, Stack, Container } from '@optimus-web/core';
import { getCustomerOrCompanyFullName } from '@mews-commander/legacy-entities/src/ducks/customers';
import { useCommanderSelector } from '@mews-commander/utils';

interface OriginalBillInfoProps {
    bills: Bill[];
    billName?: string;
}

export const OriginalBillInfo = ({ bills, billName }: OriginalBillInfoProps) => {
    const billNames = billName ? [billName] : bills.map(({ name }) => name);
    const ownerNames = useCommanderSelector((state) =>
        pipe(
            bills,
            array.uniq(eq.struct({ ownerId: string.Eq })),
            array.map(({ ownerId }) => getCustomerOrCompanyFullName(state, { id: ownerId }))
        )
    );

    if (!billNames || !ownerNames) {
        throw new Error('Bills or owner names are not defined');
    }

    return (
        <NestedCard padding="100">
            <Container padding="100">
                <Stack vertical spacing="50">
                    <Highlight size="medium" ellipsis maxLines={1}>
                        {ownerNames.join(', ')}
                    </Highlight>
                    <Body ellipsis maxLines={1}>
                        {billNames.join(', ')}
                    </Body>
                </Stack>
            </Container>
        </NestedCard>
    );
};
